import React from "react";
import { SidebarPage } from "../managersidebar";
import { NavbarPage } from "../managernavbar";
import { HeaderPage } from "../managerheader";

function ManagerLayout({ children }) {
  return (
    <>
      <div>
        <main>
          <SidebarPage />
          <NavbarPage />
          <HeaderPage />
          {children}
        </main>
      </div>
    </>
  );
}

export default ManagerLayout;
